import { __decorate, __param } from 'tslib';
import { InjectionToken, Optional, Inject, Injectable, NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { config as config$1, API_CONFIG, ApiModule } from '@ff/api';
import { BehaviorSubject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
const USER_CONFIG = new InjectionToken('user.config');

const config = {
    host: config$1.host,
    endpoints: {
        save: '/user',
        fetch: '/user',
        changePassword: '/user/password',
        resetPassword: '/user/password/reset',
        resetPasswordLink: '/user/password/email'
    }
};

// @dynamic
let UserService = class UserService {
    constructor(_config, _apiConfig, _httpClient) {
        this._config = _config;
        this._apiConfig = _apiConfig;
        this._httpClient = _httpClient;
        this._apiConfig = Object.assign(config$1, this._apiConfig);
        this._config = Object.assign(config, this._config);
        this._user = new BehaviorSubject(null);
    }
    getUser() {
        return this._user;
    }
    /**
     * Fetch user from remote server
     */
    fetch() {
        const url = this._config.host + this._config.endpoints.fetch;
        return this._httpClient.get(url, {})
            .toPromise()
            .then(response => (response.data))
            .then((user) => {
            this._user.next(user);
            return user;
        })
            .catch(() => {
            this._user.next(null);
            return null;
        });
    }
    /**
     * Save
     */
    save(form) {
        const url = this._config.host + this._config.endpoints.save;
        const hasId = form.get('id') && form.get('id').value;
        return hasId ?
            this._httpClient.put(url, form.getRawValue()).toPromise() :
            this._httpClient.post(url, form.getRawValue()).toPromise();
    }
    /**
     * Change password
     */
    changePassword(form) {
        const url = this._config.host + this._config.endpoints.changePassword;
        return this._httpClient.post(url, form.getRawValue()).toPromise();
    }
    /**
     * Reset password link
     * @param data
     */
    resetPasswordLink(data) {
        const url = this._config.host + this._config.endpoints.resetPasswordLink;
        return this._httpClient.post(url, Object.assign({}, data.value))
            .toPromise();
    }
    /**
     * Reset password
     * @param form
     */
    resetPassword(form) {
        const url = this._config.host + this._config.endpoints.resetPassword;
        return this._httpClient.post(url, form.getRawValue()).toPromise();
    }
};
UserService.ɵfac = function UserService_Factory(t) { return new (t || UserService)(ɵngcc0.ɵɵinject(USER_CONFIG, 8), ɵngcc0.ɵɵinject(API_CONFIG, 8), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
UserService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UserService, factory: function (t) { return UserService.ɵfac(t); } });
UserService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [USER_CONFIG,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [API_CONFIG,] }] },
    { type: HttpClient }
];
UserService = __decorate([ __param(0, Optional()), __param(0, Inject(USER_CONFIG)),
    __param(1, Optional()), __param(1, Inject(API_CONFIG))
], UserService);

function fetchUser(userService) {
    return () => userService.fetch();
}

const ɵ0 = fetchUser;
let UserModule = class UserModule {
};
UserModule.ɵfac = function UserModule_Factory(t) { return new (t || UserModule)(); };
UserModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UserModule });
UserModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        UserService,
        {
            provide: APP_INITIALIZER,
            useFactory: ɵ0,
            multi: true,
            deps: [UserService]
        }
    ], imports: [[
            CommonModule,
            ReactiveFormsModule,
            HttpClientModule,
            RouterModule,
            ApiModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [USER_CONFIG]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [API_CONFIG]
            }] }, { type: ɵngcc1.HttpClient }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    HttpClientModule,
                    RouterModule,
                    ApiModule
                ],
                providers: [
                    UserService,
                    {
                        provide: APP_INITIALIZER,
                        useFactory: ɵ0,
                        multi: true,
                        deps: [UserService]
                    }
                ],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UserModule, { imports: function () { return [CommonModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        ApiModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { USER_CONFIG, UserModule, UserService, fetchUser as ɵa };

